<template>
  <div class="home">    
    <HeaderNavMenu currentActiveName="Home"/>
    <div style="background-color: #f8f8f8;min-height:500px">
      <Row>
        <Col span="24" style="height: 55px;">&nbsp;</Col>
      </Row>
      <Row>
          <Col span="5">&nbsp;</Col>
          <Col span="14" class="slogan">
          <p style="display:flex;align-items: center; justify-content: center;">
            <img src="../assets/logo.png" alt=""/>     
            <label style="font-size: 1.7em;color: #4fc0e0;">{{$t("QfishOrderTracking")}}</label>
          </p>
          </Col>
          <Col span="5">&nbsp;</Col>
      </Row>
      <!-- <Row style="margin-top:20px;">
          <Col span="6">&nbsp;</Col>
          <Col span="9">        
            <Input type="textarea" :rows="10" v-model="trackingNumbers" placeholder="Enter numbers..." />
          </Col>
          <Col span="3">
            <Button type="success" style="margin:5px 0;width: 110px;height: 100px;">{{$t("Channel")}}</Button>
            <br/>
            <Button type="info" style="margin:5px 0;width: 110px;height: 100px;" v-on:click="tracking">{{$t("btn_track")}}</Button>
          </Col>
          <Col span="6">&nbsp;</Col>
      </Row> -->
      <Row style="margin-top:30px;">
          <Col span="5">&nbsp;</Col>
          <Col span="14" :style="{backgroundImage:`url(${backgroundUrl})`}">
            <div>
            <Input style="width: 70%;" type="textarea" :rows="10" v-model="trackingNumbers" :placeholder="$t('PleaseEnterNumbers')" />
            </div>
            <div style="margin-top:30px;">
            <Button icon="ios-search" type="info" style="margin:5px 0;width: 40%;height: 45px;" v-on:click="tracking">{{$t("btn_track")}}</Button>
              
            </div>
            <div style="height: 20px;"></div>
          </Col>
          <Col span="5">&nbsp;</Col>
      </Row>
      <Row>
        <Col span="24" style="height: 30px;">&nbsp;</Col>
      </Row>
    </div>
    <FooterComponent />
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderNavMenu from '@/components/HeaderNavMenu.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  name: 'home',
  data: function () {
    return {
      trackingNumbers: '',
      backgroundUrl:require('../assets/home_background_img.png')
    }
  },
  components: {
    HeaderNavMenu,
    FooterComponent
  },
  methods: {
    tracking: function () {
      console.log(this.trackingNumbers);
      //alert(this.trackingNumbers);
      this.$store.commit('setTrackingNumbers',this.trackingNumbers);
      this.$router.push('/tracking');
    }
  }
}
</script>
<style scoped>
.home{
 background-color:white; 
}

.slogan {
    font-size: 1.5em;
    text-align: center;
}

.yq-handle-btn {
    width: 110px;
    height: 110px;
}
</style>